export const SEARCHED = "blog/searched";
export const CATEGORYSEARCHED = "filter/categorysearched";
export const AUTHORPOSTSEARCHED = "filter/authorpostsearched";
